/* Custom Judge.me review widget — hydrates from jdgm.data.reviewWidget,
   proxies write-review + image lightbox + sort to the native widget. */
(function () {
  'use strict';

  var SORT_KEYS = [
    'created_at', 'highest_rating', 'lowest_rating',
    'with_pictures', 'pictures_first', 'most_helpful'
  ];

  /* EN fallbacks — overridden per-section by the [data-prv-i18n] JSON block. */
  var DEFAULT_I18N = {
    write_review: 'Write A Review',
    loading: 'Loading reviews',
    rating_aria: '[rating] out of 5 stars',
    based_on_one: 'Based on [count] review',
    based_on_other: 'Based on [count] reviews',
    sort_label: 'Sort By:',
    sort_aria: 'Sort reviews by',
    sort_newest: 'Newest',
    sort_highest_rating: 'Highest rating',
    sort_lowest_rating: 'Lowest rating',
    sort_with_pictures: 'Only pictures',
    sort_pictures_first: 'Pictures first',
    sort_most_helpful: 'Most helpful',
    anonymous: 'Anonymous',
    verified_buyer: 'Verified Buyer',
    open_photo: 'Open photo [index]',
    open_review_photo: 'Open review photo [index]',
    pagination_aria: 'Reviews pagination',
    previous_page: 'Previous page',
    next_page: 'Next page'
  };

  /* Sort key → i18n key. 'created_at' reads as "Newest" in the dropdown. */
  var SORT_I18N_KEY = {
    created_at: 'sort_newest',
    highest_rating: 'sort_highest_rating',
    lowest_rating: 'sort_lowest_rating',
    with_pictures: 'sort_with_pictures',
    pictures_first: 'sort_pictures_first',
    most_helpful: 'sort_most_helpful'
  };

  function readI18n(host) {
    var out = {};
    for (var k in DEFAULT_I18N) out[k] = DEFAULT_I18N[k];
    var el = host.querySelector('[data-prv-i18n]');
    if (!el) return out;
    try {
      var parsed = JSON.parse(el.textContent);
      for (var key in parsed) {
        if (parsed[key]) out[key] = parsed[key];
      }
    } catch (e) {}
    return out;
  }

  /* Replace [name] placeholders — matches the theme's JS-side locale convention. */
  function interpolate(str, vars) {
    return String(str).replace(/\[(\w+)\]/g, function (m, name) {
      return Object.prototype.hasOwnProperty.call(vars, name) ? vars[name] : m;
    });
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d)) return '';
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    var yy = String(d.getFullYear()).slice(-2);
    return mm + '/' + dd + '/' + yy;
  }

  function starsSvg(rating) {
    var r = Math.round(Number(rating) * 2) / 2;
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var fill;
      if (i <= r)        fill = 'full';
      else if (i - 0.5 === r) fill = 'half';
      else                fill = 'empty';
      html += starShape(fill);
    }
    return html;
  }

  function starShape(fill) {
    var path = '<path d="M10 1.5l2.6 5.27 5.82.85-4.21 4.1.99 5.79L10 14.77 4.8 17.51l.99-5.79L1.58 7.62l5.82-.85L10 1.5z"/>';
    if (fill === 'full') {
      return '<svg class="prv-star prv-star--full" viewBox="0 0 20 20" aria-hidden="true">' + path + '</svg>';
    }
    if (fill === 'half') {
      return '<svg class="prv-star prv-star--half" viewBox="0 0 20 20" aria-hidden="true">' +
        '<defs><clipPath id="prv-half"><rect x="0" y="0" width="10" height="20"/></clipPath></defs>' +
        '<path class="prv-star-bg" d="M10 1.5l2.6 5.27 5.82.85-4.21 4.1.99 5.79L10 14.77 4.8 17.51l.99-5.79L1.58 7.62l5.82-.85L10 1.5z"/>' +
        '<path clip-path="url(#prv-half)" d="M10 1.5l2.6 5.27 5.82.85-4.21 4.1.99 5.79L10 14.77 4.8 17.51l.99-5.79L1.58 7.62l5.82-.85L10 1.5z"/>' +
        '</svg>';
    }
    return '<svg class="prv-star prv-star--empty" viewBox="0 0 20 20" aria-hidden="true">' + path + '</svg>';
  }

  function chevronDown() {
    return '<svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true"><path d="M2 4l4 4 4-4" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  function arrow(dir) {
    var d = dir === 'left' ? 'M10 12L6 8L10 4' : 'M6 4L10 8L6 12';
    return '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
      '<path d="' + d + '" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
  }

  function renderLoading(t) {
    return '<div class="prv-loading">' +
      '<svg class="prv-spinner" viewBox="0 0 24 24" fill="none" aria-label="' + escapeHtml(t.loading) + '">' +
        '<circle cx="12" cy="12" r="10" stroke="var(--stroke, #E5E5E5)" stroke-width="2"/>' +
        '<path d="M12 2a10 10 0 0 1 10 10" stroke="var(--black, #2d3232)" stroke-width="2" stroke-linecap="round"/>' +
      '</svg>' +
    '</div>';
  }

  /* Flatten photo_gallery → array of { url_small, url_large, review_uuid, pic_idx } */
  function buildPhotoIndex(data) {
    var out = [];
    var gallery = data.photo_gallery || [];
    for (var i = 0; i < gallery.length; i++) {
      var entry = gallery[i];
      var pics = entry.pictures_urls || [];
      for (var j = 0; j < pics.length; j++) {
        var pic = pics[j];
        out.push({
          url_small: pic.compact || pic.small || pic.original,
          url_large: pic.huge || pic.original,
          review_uuid: entry.uuid,
          pic_idx: j
        });
      }
    }
    return out;
  }

  function sortReviews(reviews, key) {
    var r = reviews.slice();
    if (key === 'created_at')
      return r.sort(function (a, b) { return new Date(b.created_at) - new Date(a.created_at); });
    if (key === 'highest_rating')
      return r.sort(function (a, b) { return Number(b.rating) - Number(a.rating); });
    if (key === 'lowest_rating')
      return r.sort(function (a, b) { return Number(a.rating) - Number(b.rating); });
    if (key === 'with_pictures')
      return r.filter(function (x) { return (x.pictures_urls || []).length > 0; });
    if (key === 'pictures_first')
      return r.sort(function (a, b) {
        var ap = (a.pictures_urls || []).length > 0 ? 1 : 0;
        var bp = (b.pictures_urls || []).length > 0 ? 1 : 0;
        if (bp - ap !== 0) return bp - ap;
        return new Date(b.created_at) - new Date(a.created_at);
      });
    if (key === 'most_helpful')
      return r.sort(function (a, b) {
        return (Number(b.thumb_up || 0) - Number(b.thumb_down || 0))
             - (Number(a.thumb_up || 0) - Number(a.thumb_down || 0));
      });
    return r;
  }

  function renderHeader(data, heading, t) {
    var avg = Number(data.average_rating || 0).toFixed(1);
    var total = data.number_of_reviews || 0;
    var basedOn = interpolate(total === 1 ? t.based_on_one : t.based_on_other, { count: total });

    return '' +
      '<header class="prv-header">' +
        '<h2 class="h3 prv-title tc">' + escapeHtml(heading) + '</h2>' +
        '<div class="prv-summary">' +
          '<div class="prv-summary-row">' +
            '<span class="h4 prv-avg">' + escapeHtml(avg) + '</span>' +
            '<span class="prv-stars" aria-label="' + escapeHtml(interpolate(t.rating_aria, { rating: avg })) + '">' + starsSvg(avg) + '</span>' +
          '</div>' +
          '<p class="p3 prv-summary-text">' + escapeHtml(basedOn) + '</p>' +
        '</div>' +
        '<button type="button" class="prv-btn-cta" data-prv-write-review>' +
          '<span class="p2 bold">' + escapeHtml(t.write_review) + '</span>' +
        '</button>' +
      '</header>';
  }

  function chatIcon() {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">' +
      '<path d="M5.0087 16.2008L8.76522 12.4443H14.2C15.3046 12.4443 16.2 11.5488 16.2 10.4443V3.80078C16.2 2.69621 15.3046 1.80078 14.2 1.80078H3.8C2.69543 1.80078 1.8 2.69621 1.8 3.80078V10.4443C1.8 11.5488 2.69543 12.4443 3.8 12.4443H5.0087V16.2008Z" stroke="var(--new-pink, #F4A2C8)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
  }

  function renderEmpty(heading, emptyText, t) {
    var msg = emptyText || 'No reviews yet — be the first to share yours.';
    return '' +
      '<header class="prv-header">' +
        '<h2 class="h3 prv-title tc">' + escapeHtml(heading) + '</h2>' +
      '</header>' +
      '<div class="prv-empty">' +
        '<span class="prv-empty-icon" aria-hidden="true">' + chatIcon() + '</span>' +
        '<p class="p2 prv-empty-text">' + escapeHtml(msg) + '</p>' +
      '</div>' +
      '<button type="button" class="prv-btn-cta prv-btn-cta--full" data-prv-write-review>' +
        '<span class="p2 bold">' + escapeHtml(t.write_review) + '</span>' +
      '</button>';
  }

  function renderPhotoStrip(photoIndex, isDesktop, t) {
    if (!photoIndex.length) return '';
    var limit = isDesktop ? 6 : 4;
    var html = '<div class="prv-photo-strip">';
    for (var i = 0; i < Math.min(photoIndex.length, limit); i++) {
      var p = photoIndex[i];
      var label = interpolate(t.open_review_photo, { index: i + 1 });
      html += '<button type="button" class="prv-photo" data-prv-open-photo="' + i + '" aria-label="' + escapeHtml(label) + '">' +
                '<img src="' + escapeHtml(p.url_small) + '" alt="" loading="lazy">' +
              '</button>';
    }
    html += '</div>';
    return html;
  }

  function renderSort(currentSort, t) {
    var html = '<div class="prv-sort-row">' +
      '<span class="p2 prv-sort-label">' + escapeHtml(t.sort_label) + '</span>' +
      '<div class="prv-sort">' +
        '<select class="p2 prv-sort-select" data-prv-sort aria-label="' + escapeHtml(t.sort_aria) + '">';
    SORT_KEYS.forEach(function (value) {
      var label = t[SORT_I18N_KEY[value]];
      html += '<option value="' + value + '"' + (value === currentSort ? ' selected' : '') + '>' + escapeHtml(label) + '</option>';
    });
    html += '</select>' +
        '<span class="prv-sort-icon" aria-hidden="true">' + chevronDown() + '</span>' +
      '</div>' +
    '</div>';
    return html;
  }

  function renderReview(review, t) {
    var name = review.is_anonymous_reviewer ? t.anonymous : (review.reviewer_name || t.anonymous);
    var date = formatDate(review.created_at);
    var verified = review.verified_buyer;
    var title = review.title || '';
    var body = review.body_html || ('<p>' + escapeHtml(review.body || '') + '</p>');
    var rating = Number(review.rating) || 0;
    var pics = review.pictures_urls || [];

    var picsHtml = '';
    if (pics.length) {
      picsHtml = '<div class="prv-review-photos">';
      for (var i = 0; i < pics.length; i++) {
        var p = pics[i];
        var picLabel = interpolate(t.open_photo, { index: i + 1 });
        picsHtml += '<button type="button" class="prv-review-photo" data-prv-open-review-photo="' + i + '" data-review-uuid="' + escapeHtml(review.uuid) + '" aria-label="' + escapeHtml(picLabel) + '">' +
                      '<img src="' + escapeHtml(p.compact || p.small || p.original) + '" alt="" loading="lazy">' +
                    '</button>';
      }
      picsHtml += '</div>';
    }

    return '<article class="prv-review" data-review-uuid="' + escapeHtml(review.uuid) + '">' +
      '<div class="prv-stars prv-review-stars" role="img" aria-label="' + escapeHtml(interpolate(t.rating_aria, { rating: rating })) + '">' + starsSvg(rating) + '</div>' +
      '<div class="prv-reviewer">' +
        '<div class="prv-reviewer-row">' +
          '<span class="p2 bold prv-reviewer-name">' + escapeHtml(name) + '</span>' +
          '<span class="p4 prv-verified">' + escapeHtml(t.verified_buyer) + '</span>' +
        '</div>' +
        '<span class="p2 prv-date">' + escapeHtml(date) + '</span>' +
      '</div>' +
      '<div class="prv-content">' +
        (title ? '<h3 class="h5 prv-review-title">' + escapeHtml(title) + '</h3>' : '') +
        '<div class="p2 prv-body rte">' + body + '</div>' +
      '</div>' +
      picsHtml +
    '</article>';
  }

  function renderPagination(totalPages, currentPage, t) {
    if (totalPages <= 1) return '';
    var html = '<nav class="prv-pagination" data-prv-pagination aria-label="' + escapeHtml(t.pagination_aria) + '">';
    html += '<button type="button" class="prv-page-arrow" data-prv-page="' + (currentPage - 1) + '"' +
            (currentPage <= 1 ? ' disabled' : '') + ' aria-label="' + escapeHtml(t.previous_page) + '">' + arrow('left') + '</button>';
    html += '<div class="prv-page-numbers">';
    var pages = paginationRange(totalPages, currentPage);
    for (var i = 0; i < pages.length; i++) {
      var p = pages[i];
      if (p === '…') {
        html += '<span class="prv-page-ellipsis p2">…</span>';
      } else {
        html += '<button type="button" class="prv-page p2' + (p === currentPage ? ' is-active' : '') + '" data-prv-page="' + p + '"' +
                (p === currentPage ? ' aria-current="page"' : '') + '>' + p + '</button>';
      }
    }
    html += '</div>';
    html += '<button type="button" class="prv-page-arrow" data-prv-page="' + (currentPage + 1) + '"' +
            (currentPage >= totalPages ? ' disabled' : '') + ' aria-label="' + escapeHtml(t.next_page) + '">' + arrow('right') + '</button>';
    html += '</nav>';
    return html;
  }

  function paginationRange(total, current) {
    if (total <= 5) {
      var arr = [];
      for (var i = 1; i <= total; i++) arr.push(i);
      return arr;
    }
    var pages = [1];
    if (current > 3) pages.push('…');
    var start = Math.max(2, current - 1);
    var end = Math.min(total - 1, current + 1);
    for (var j = start; j <= end; j++) pages.push(j);
    if (current < total - 2) pages.push('…');
    pages.push(total);
    return pages;
  }

  /* Proxy helpers — drive the hidden Judge.me widget. */

  function clickWriteReview() {
    var btn = $('.prv-widget-host [data-testid="write-review-button"]');
    if (btn) { btn.click(); return; }
    /* Widget not yet mounted — retry briefly. */
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var b = $('.prv-widget-host [data-testid="write-review-button"]');
      if (b) { clearInterval(iv); b.click(); return; }
      if (tries > 20) clearInterval(iv);
    }, 150);
  }


  /* Open lightbox for a photo in the global gallery (top strip). */
  function openGalleryPhoto(index) {
    var items = $$('.prv-widget-host .jm-media-grid__item');
    /* The first set of grid items belongs to the photo gallery (top of widget). */
    var galleryItems = items.filter(function (el) {
      return el.closest('.jm-media-preview') != null;
    });
    var target = galleryItems[index];
    if (target) { target.click(); return; }
    /* Retry until widget mounts. */
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var its = $$('.prv-widget-host .jm-media-grid__item').filter(function (el) {
        return el.closest('.jm-media-preview') != null;
      });
      if (its[index]) { clearInterval(iv); its[index].click(); return; }
      if (tries > 20) clearInterval(iv);
    }, 150);
  }

  /* Open lightbox for a photo inside a specific review. */
  function openReviewPhoto(reviewUuid, picIdx) {
    var reviewEl = $('.prv-widget-host [review-uuid="' + reviewUuid + '"]');
    if (!reviewEl) return;
    var thumbs = $$('.jm-frame.jm-media-thumbnail-list__thumbnail', reviewEl);
    var target = thumbs[picIdx];
    if (target) target.click();
  }

  /* Boot */

  function extractReviewFromNativeEl(el, t) {
    var ratingEl = el.querySelector('.jm-star-rating');
    var rating = ratingEl
      ? Number((ratingEl.getAttribute('aria-label') || '').match(/(\d+(?:\.\d+)?)/)?.[1] || 0)
      : 0;
    var name = (el.querySelector('.jm-reviewer-info__name') || {}).textContent;
    name = name ? name.trim() : t.anonymous;

    var dateStr = '';
    var texts = el.querySelectorAll('.jm-text');
    for (var i = 0; i < texts.length; i++) {
      if (/\d{2}\/\d{2}\/\d{4}/.test(texts[i].textContent)) {
        dateStr = texts[i].textContent.trim();
        break;
      }
    }
    var created_at = '';
    if (dateStr) {
      var p = dateStr.split('/');
      if (p.length === 3) created_at = p[2] + '-' + p[0] + '-' + p[1];
    }

    var titleEl = el.querySelector('[class*="review-content__title"]');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var bodyEl = el.querySelector('.jm-review-content__body');
    var bodyText = bodyEl ? bodyEl.textContent.trim() : '';

    var picImgs = el.querySelectorAll('.jm-media-grid__item img');
    var pictures_urls = Array.prototype.map.call(picImgs, function (img) {
      return { compact: img.src, small: img.src, original: img.src };
    });

    return {
      uuid: el.getAttribute('review-uuid') || '',
      rating: rating,
      reviewer_name: name,
      created_at: created_at,
      title: title,
      body: bodyText,
      body_html: '<p>' + escapeHtml(bodyText) + '</p>',
      pictures_urls: pictures_urls,
      verified_buyer: !!el.querySelector('[class*="verified"]'),
      is_anonymous_reviewer: !name || name === t.anonymous
    };
  }

  function initNativeWidget(host) {
    var container = host.parentElement;
    var widgetHost = container && container.querySelector('.prv-widget-host');
    if (!widgetHost) return null;
    var widgetEl = widgetHost.querySelector('[data-widget="review"]');
    if (!widgetEl || !window.jdgm) return null;
    widgetEl.removeAttribute('data-auto-install');
    try { jdgm.initializeWidgets(jdgm.$(widgetEl)); } catch (e) {}
    return widgetEl;
  }

  function fetchNativePage(widgetEl, page, t, callback) {
    function collect() {
      return Array.prototype.map.call(widgetEl.querySelectorAll('[review-uuid]'), function (el) {
        return extractReviewFromNativeEl(el, t);
      });
    }

    var btn = widgetEl.querySelector('button[aria-label="Go to page ' + page + '"]');
    if (!btn) {
      callback(collect());
      return;
    }

    var reviewList = widgetEl.querySelector('[class*="review-list"]');
    var done = false;

    function finish() {
      if (done) return;
      done = true;
      observer.disconnect();
      callback(collect());
    }

    var observer = new MutationObserver(function () { setTimeout(finish, 100); });
    if (reviewList) observer.observe(reviewList, { childList: true, subtree: true });
    btn.click();
    setTimeout(finish, 4000);
  }

  function hydrate(host) {
    var productId = host.getAttribute('data-product-id');
    var perPage = Number(host.getAttribute('data-per-page')) || 5;
    var t = readI18n(host);

    var data = (window.jdgm && jdgm.data && jdgm.data.reviewWidget && jdgm.data.reviewWidget[productId]) || null;

    if (!data || !data.reviews || data.reviews.length === 0) {
      var emptyRoot = $('[data-prv-root]', host);
      var emptyHeading = host.getAttribute('data-title') || 'What the Girls Are Saying';
      var emptyText = host.getAttribute('data-empty-text') || '';
      if (emptyRoot) emptyRoot.innerHTML = renderEmpty(emptyHeading, emptyText, t);
      host.addEventListener('click', function (e) {
        if (e.target.closest('[data-prv-write-review]')) {
          e.preventDefault();
          clickWriteReview();
        }
      });
      return;
    }

    var totalReviews = Number(data.number_of_reviews || data.reviews.length);
    var nativeWidgetEl = totalReviews > data.reviews.length ? initNativeWidget(host) : null;

    var state = {
      sort: 'created_at',
      page: 1,
      perPage: perPage,
      data: data
    };

    var heading = host.getAttribute('data-title') || 'What the Girls Are Saying';
    var photoIndex = buildPhotoIndex(data);
    var root = $('[data-prv-root]', host);

    function paintShell(listHtml, totalPages) {
      var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      root.innerHTML =
        renderHeader(data, heading, t) +
        renderPhotoStrip(photoIndex, isDesktop, t) +
        '<div class="prv-body">' +
          renderSort(state.sort, t) +
          '<div class="prv-divider" role="separator"></div>' +
          '<div class="prv-reviews" data-prv-list>' + listHtml + '</div>' +
          renderPagination(totalPages, state.page, t) +
        '</div>';
    }

    function paint() {
      var totalPages = Math.max(1, Math.ceil(totalReviews / state.perPage));
      if (state.page > totalPages) state.page = totalPages;

      if (state.page > 1 && nativeWidgetEl) {
        paintShell(renderLoading(t), totalPages);
        fetchNativePage(nativeWidgetEl, state.page, t, function (reviews) {
          var list = root.querySelector('[data-prv-list]');
          if (list) list.innerHTML = reviews.map(function (r) { return renderReview(r, t); }).join('');
        });
      } else {
        var sorted = sortReviews(data.reviews, state.sort);
        var start = (state.page - 1) * state.perPage;
        var slice = sorted.slice(start, start + state.perPage);
        paintShell(slice.map(function (r) { return renderReview(r, t); }).join(''), totalPages);
      }
    }

    paint();

    /* Single delegated click handler. */
    host.addEventListener('click', function (e) {
      var t = e.target.closest('[data-prv-write-review], [data-prv-open-photo], [data-prv-open-review-photo], [data-prv-page]');
      if (!t) return;

      if (t.hasAttribute('data-prv-write-review')) {
        e.preventDefault();
        clickWriteReview();
        return;
      }
      if (t.hasAttribute('data-prv-open-photo')) {
        e.preventDefault();
        openGalleryPhoto(Number(t.getAttribute('data-prv-open-photo')));
        return;
      }
      if (t.hasAttribute('data-prv-open-review-photo')) {
        e.preventDefault();
        var uuid = t.getAttribute('data-review-uuid');
        var idx = Number(t.getAttribute('data-prv-open-review-photo'));
        openReviewPhoto(uuid, idx);
        return;
      }
      if (t.hasAttribute('data-prv-page')) {
        e.preventDefault();
        if (t.disabled) return;
        var p = Number(t.getAttribute('data-prv-page'));
        if (!p || p < 1) return;
        state.page = p;
        paint();
        host.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    host.addEventListener('change', function (e) {
      if (e.target && e.target.matches('[data-prv-sort]')) {
        state.sort = e.target.value;
        state.page = 1;
        paint();
      }
    });

    /* Re-paint photo strip on breakpoint change to swap thumbnail count. */
    var mql = window.matchMedia('(min-width: 1024px)');
    var onBp = function () { paint(); };
    if (mql.addEventListener) mql.addEventListener('change', onBp);
    else if (mql.addListener) mql.addListener(onBp);
  }

  function init() {
    $$('[data-product-reviews]').forEach(hydrate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1 || !node.classList.contains('jdgm-write-review-modal')) return;
        var overlay = node.querySelector('.jdgm-write-review-modal__overlay');
        if (!overlay) return;
        overlay.addEventListener('click', function () {
          var closeBtn = node.querySelector('.jdgm-write-review-modal__close-btn');
          if (closeBtn) closeBtn.click();
        });
      });
    });
  });
  observer.observe(document.body, { childList: true });
})();

(function () {
  function patch() {
    if (!window.jdgm || !jdgm._WriteReviewModal) return false;
    var orig = jdgm._WriteReviewModal.prototype._closeModal;
    jdgm._WriteReviewModal.prototype._closeModal = function (e) {
      var $m = this.$modal;
      if ($m) {
        $m.fadeOut = function (speed, cb) {
          delete $m.fadeOut;
          return jdgm.$.fn.fadeOut.call($m, 300, cb);
        };
      }
      return orig.call(this, e);
    };
    return true;
  }
  if (!patch()) {
    var iv = setInterval(function () { if (patch()) clearInterval(iv); }, 100);
  }
})();
